var unlockerSound = new Howl({
	src: ['media/audio/sounds/nothing.mp3']
});
unlockerSound.on('unlock', function () {
	// console.log('HOWLER: Audio unlocked.');
	hidePreloader();
	unlockerSound.play();
});
unlockerSound.on('play', function () {
	// console.log('HOWLER: Audio playing.');
	hidePreloader();
});
unlockerSound.play();

function initPreloader() {
	// SETUP THE PRELOADER
	window.onload = function () {
		$('#preloader_text_1').fadeOut('slow', function () {
			$('#preloader_text_2').fadeIn('slow');
		});
		$('#Preloader').on('click touch', function (e) {
			e.preventDefault();
			siAudio.sfx.click.play();
			hidePreloader();
		});
	};
	// $('section.present').hide();
}

function hidePreloader() {
	$('#Preloader').fadeOut('slow', function () {
		$('section.present').fadeIn('slow', function () {
			if (slides[globalVar.curSlide] !== undefined && slides[globalVar.curSlide].type == 'video') {
				var video = globalVar.$curSlide.find('video')[0];
				videojs(video.playerId).play();
			}
		});
	});
}

// initPreloader()
